import { render, staticRenderFns } from "./DispatchRowActions.vue?vue&type=template&id=93b56738"
import script from "./DispatchRowActions.vue?vue&type=script&lang=js"
export * from "./DispatchRowActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports